import script from "./PropHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PropHeader.vue?vue&type=style&index=0&id=faff910a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faff910a"]])

export default __exports__